import PropTypes from 'prop-types';

import useIsUserAllowedByPermission
  from '../hooks/useIsUserAllowedByPermission';

export function MenuHasPermission({ children, item }) {
  const isAllowd = useIsUserAllowedByPermission(item.permission || item.roles);

  if (isAllowd) {
    return children;
  }

  return null;
}

export default MenuHasPermission;

MenuHasPermission.propTypes = {
  children: PropTypes.node.isRequired
};
